import { render, staticRenderFns } from "./profile-account.vue?vue&type=template&id=3f5ee17c&"
import script from "./profile-account.vue?vue&type=script&lang=js&"
export * from "./profile-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports